import { render, staticRenderFns } from "./DownloadApps.vue?vue&type=template&id=1bf1dd79&"
import script from "./DownloadApps.vue?vue&type=script&lang=js&"
export * from "./DownloadApps.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports